import { render, staticRenderFns } from "./WxWorkListPanel.vue?vue&type=template&id=08ecc371&scoped=true&"
import script from "./WxWorkListPanel.vue?vue&type=script&lang=js&"
export * from "./WxWorkListPanel.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkListPanel.vue?vue&type=style&index=0&id=08ecc371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecc371",
  null
  
)

export default component.exports